module.exports = __webpack_public_path__ + "img/bg7.6e1d3be0.jpg";